// extracted by mini-css-extract-plugin
module.exports = {"notEditing":"EditorInput_notEditing__2WsN3","multiLine":"EditorInput_multiLine__2q4PA","empty":"EditorInput_empty__1C6n2"};